export default {
  namespaced: true,
  state     : {
    news_items: [
      {
        id      : 2,
        text    : 'Новость',
        type    : 'news',
        selected: false,
      },
      {
        id      : 3,
        text    : 'Мероприятие',
        type    : 'events',
        selected: false,
      },
    ],
    selected_item: {},
  },
  getters: {
    current_item: ({news_items}) => news_items.find((x) => x.selected),
    items       : ({news_items}) => news_items,
  },
  mutations: {
    SET_CURRENT_ITEM(state, value) {
      state.news_items.forEach((x) => {
        x.selected = false;
      });
      const item = state.news_items.find((x)=>x.type == value);
      state.current_item = item;
      state.current_item.selected = true;
    },
  },
};
